export type SectorId = 'B-1' | 'B-2' | 'B-3' | 'B-4' | 'C-1' | 'C-2' | 'C-3' | 'D-1';
export type SectorTier = 'EASY' | 'NORMAL' | 'HARD' | 'BOSS' | '???';
export type SectorMod = null | 'biohazard' | 'storm' | 'boss';
export type SectorZoneId = 'bravo' | 'charlie' | 'delta';

export type SectorDef = {
  id: SectorId;
  zone: SectorZoneId;
  label: string;
  tier: SectorTier;
  hostility: 1 | 2 | 3 | 4 | 5;
  mult: number;
  mod: SectorMod;
  requiresWin: SectorId | null;
};

export type SectorZone = {
  id: SectorZoneId;
  code: 'B' | 'C' | 'D';
  nameKey: 'sector.zone.bravo' | 'sector.zone.charlie' | 'sector.zone.delta';
  subKey: 'sector.zone.bravo.sub' | 'sector.zone.charlie.sub' | 'sector.zone.delta.sub';
  color: string;
  sectors: readonly SectorId[];
};

export const SECTORS: readonly SectorDef[] = [
  { id: 'B-1', zone: 'bravo',   label: 'B-1', tier: 'EASY',   hostility: 1, mult: 1.0, mod: null,        requiresWin: null },
  { id: 'B-2', zone: 'bravo',   label: 'B-2', tier: 'EASY',   hostility: 1, mult: 1.0, mod: null,        requiresWin: 'B-1' },
  { id: 'B-3', zone: 'bravo',   label: 'B-3', tier: 'NORMAL', hostility: 2, mult: 1.4, mod: null,        requiresWin: 'B-2' },
  { id: 'B-4', zone: 'bravo',   label: 'B-4', tier: 'NORMAL', hostility: 2, mult: 1.5, mod: 'biohazard', requiresWin: 'B-3' },
  { id: 'C-1', zone: 'charlie', label: 'C-1', tier: 'HARD',   hostility: 3, mult: 1.8, mod: 'storm',     requiresWin: 'B-4' },
  { id: 'C-2', zone: 'charlie', label: 'C-2', tier: 'HARD',   hostility: 3, mult: 2.0, mod: null,        requiresWin: 'C-1' },
  { id: 'C-3', zone: 'charlie', label: 'C-3', tier: 'BOSS',   hostility: 4, mult: 2.5, mod: 'boss',      requiresWin: 'C-2' },
  { id: 'D-1', zone: 'delta',   label: 'D-1', tier: '???',    hostility: 5, mult: 3.0, mod: null,        requiresWin: 'C-3' },
];

export const SECTOR_ZONES: readonly SectorZone[] = [
  { id: 'bravo',   code: 'B', nameKey: 'sector.zone.bravo',   subKey: 'sector.zone.bravo.sub',   color: '#4ad06b', sectors: ['B-1', 'B-2', 'B-3', 'B-4'] },
  { id: 'charlie', code: 'C', nameKey: 'sector.zone.charlie', subKey: 'sector.zone.charlie.sub', color: '#f5c542', sectors: ['C-1', 'C-2', 'C-3'] },
  { id: 'delta',   code: 'D', nameKey: 'sector.zone.delta',   subKey: 'sector.zone.delta.sub',   color: '#ff4a4a', sectors: ['D-1'] },
];

/** Map a SectorTier to a literal-hex accent. Used by SectorNode + SectorPreviewModal. */
export function tierColor(tier: SectorTier): string {
  switch (tier) {
    case 'EASY':   return '#4ad06b';
    case 'NORMAL': return '#3dd5ff';
    case 'HARD':   return '#ff9a3c';
    case 'BOSS':   return '#ff4a4a';
    case '???':    return '#8a96ad';
  }
}
